import { render, staticRenderFns } from "./financial-data-details.vue?vue&type=template&id=6228122c&scoped=true&"
import script from "./financial-data-details.vue?vue&type=script&lang=js&"
export * from "./financial-data-details.vue?vue&type=script&lang=js&"
import style0 from "./financial-data-details.vue?vue&type=style&index=0&id=6228122c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228122c",
  null
  
)

export default component.exports